<template>
    <div class="sendEmail">
        <el-card shadow="never" class="box-card" style="margin-bottom: 8px;">
            <div class="sendbox">
                <div class="boxitem">
                    <span class="name">收件人</span>
                    <el-input class="value" v-model="name" disabled></el-input>
                </div>
                <div class="boxitem">
                    <span class="name">主题</span>
                    <el-input class="value" v-model="subject" placeholder="请输入邮件主题"></el-input>
                </div>
                <div class="boxitem">
                    <span class="name">模版</span>
                    <el-select class="value" v-model="templateId" filterable placeholder="请选择" style="height:40px;"
                        @change="selectTemp">
                        <el-option v-for="item in templateList" :key="item.name" :label="item.name" :value="item.content">
                        </el-option>
                    </el-select>
                </div>

                <Editor
                    style="box-sizing: border-box;min-height:500px;width:100%; overflow-y: hidden;background: #fff;border: 1px solid #ccc;border-radius: 5px;padding:8px"
                    v-model="html" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />

                <!-- <el-input ref="html" type="textarea" :rows="25" placeholder="请输入内容..." v-model="html">
                </el-input> -->
            </div>
            <div>
                <el-button style="width: 100%;margin-top:8px" type="primary" @click="submit">发送</el-button>
            </div>
        </el-card>

    </div>
</template>
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue' // 引入子组件
import { DomEditor } from '@wangeditor/editor'
import { TEMPLATES, SENDEMAIL, QUERY, QUERYMAINPERMIT } from '@/api/emial'
export default {
    components: { Editor },
    data() {
        return {
            editor: null,
            toolbarConfig: {},
            name: this.$route.query.name,
            allianceCode: this.$route.query.allianceCode,
            templateList: [],
            templateId: '',
            subject: '',
            html: '',
            editorConfig: { placeholder: '请输入内容...' },
            mode: 'default',
        }
    },
    created() {
        this.templateshtml()
    },
    methods: {
        // 获取邮件模板
        templateshtml() {
            TEMPLATES().then(res => {
                this.templateList = res.data.body
            })
        },
        selectTemp(e) {
            this.html = e
        },
        onCreated(editor) {
            this.editor = Object.seal(editor)
            this.toolbarConfig = {
                excludeKeys: [
                    'insertVideo',
                    'uploadVideo',
                    'group-video',
                    "group-image",
                    "insertLink",
                    "fullScreen",
                    "codeBlock"
                ]
            }


        },
        // 发送邮件
        submit() {
            if (!this.allianceCode) {
                this.$message({
                    message: "没有收件人",
                    type: "warning",
                });
                return
            }
            if (!this.subject) {
                this.$message({
                    message: "请输入邮件主题",
                    type: "warning",
                });
                return
            }
            if (!this.html) {
                this.$message({
                    message: "请输入邮件内容",
                    type: "warning",
                });
                return
            }
            let content = this.html.replace(/<[^>]*>|/g, "")
            let arr = this.allianceCode.split(',')
            let data = {
                allianceCodes: arr,
                subject: this.subject,
                contentText: content,
                contentHtml: this.html
            }
            SENDEMAIL(data).then(res => {
                if (res.data.code == 'error') {
                    this.$message({
                        message: res.data.msg,
                        type: "warning",
                    });
                } else {
                    this.$message({
                        message: '发送成功',
                        type: "success",
                    });
                    this.$router.push('/outbox-m')
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
.sendEmail {
    height: 100%;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding: 8px 8px 8px 8px;
    background-color: #fff;

    /deep/.el-card__body {
        padding: 8px !important;
    }

    .boxitem {
        margin-bottom: 8px;

        .name {
            display: inline-block;
            width: 70px;
        }

        .value {
            width: calc(100% - 75px) !important;
        }
    }
}
</style>